// ✅ Phase 3.1 — Staff idarəsi (yalnız admin) reducer
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_staff = createAsyncThunk(
    'staff/get_staff',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/admin/staff', { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Staff siyahısı yüklənmədi' })
        }
    }
)

export const create_staff = createAsyncThunk(
    'staff/create_staff',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/admin/staff', info, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Staff yaradıla bilmədi' })
        }
    }
)

export const update_staff = createAsyncThunk(
    'staff/update_staff',
    async ({ id, ...info }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.patch(`/admin/staff/${id}`, info, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Staff yenilənə bilmədi' })
        }
    }
)

export const set_staff_status = createAsyncThunk(
    'staff/set_staff_status',
    async ({ id, status }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.patch(`/admin/staff/${id}/status`, { status }, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Status dəyişdirilə bilmədi' })
        }
    }
)

export const update_staff_permissions = createAsyncThunk(
    'staff/update_staff_permissions',
    async ({ id, permissions }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.patch(`/admin/staff/${id}/permissions`, { permissions }, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'İcazələr yenilənə bilmədi' })
        }
    }
)

export const reset_staff_password = createAsyncThunk(
    'staff/reset_staff_password',
    async ({ id, password }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.patch(`/admin/staff/${id}/password`, { password }, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Şifrə dəyişdirilə bilmədi' })
        }
    }
)

export const staffReducer = createSlice({
    name: 'staff',
    initialState: {
        staff: [],
        loader: false,
        successMessage: '',
        errorMessage: ''
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ''
            state.successMessage = ''
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(get_staff.pending, (state) => { state.loader = true })
            .addCase(get_staff.fulfilled, (state, { payload }) => {
                state.loader = false
                state.staff = payload.staff || []
            })
            .addCase(get_staff.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Xəta'
            })

            .addCase(create_staff.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
                if (payload.staff) state.staff = [payload.staff, ...state.staff]
            })
            .addCase(create_staff.rejected, (state, { payload }) => {
                state.errorMessage = payload?.error || 'Xəta'
            })

            .addCase(update_staff.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
                if (payload.staff) {
                    state.staff = state.staff.map(s => s.id === payload.staff.id ? payload.staff : s)
                }
            })
            .addCase(update_staff.rejected, (state, { payload }) => {
                state.errorMessage = payload?.error || 'Xəta'
            })

            .addCase(set_staff_status.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
                if (payload.staff) {
                    state.staff = state.staff.map(s => s.id === payload.staff.id ? payload.staff : s)
                }
            })
            .addCase(set_staff_status.rejected, (state, { payload }) => {
                state.errorMessage = payload?.error || 'Xəta'
            })

            .addCase(update_staff_permissions.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
                if (payload.staff) {
                    state.staff = state.staff.map(s => s.id === payload.staff.id ? payload.staff : s)
                }
            })
            .addCase(update_staff_permissions.rejected, (state, { payload }) => {
                state.errorMessage = payload?.error || 'Xəta'
            })

            .addCase(reset_staff_password.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
            })
            .addCase(reset_staff_password.rejected, (state, { payload }) => {
                state.errorMessage = payload?.error || 'Xəta'
            })
    }
})

export const { messageClear } = staffReducer.actions
export default staffReducer.reducer
